import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.to-string";
import "core-js/modules/web.dom-collections.for-each";
import _Message2 from "element-ui/lib/theme-chalk/message.css";
import "element-ui/lib/theme-chalk/base.css";
import _Message from "element-ui/lib/message";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import SlotCounterFinancial from '@/components/Counter/SlotCounterFinancial';
import moment from 'moment';
export default {
  name: 'FinancialAllDiff',
  components: {
    SlotCounterFinancial: SlotCounterFinancial
  },
  data: function data() {
    var _this = this;

    return {
      datePickerValue: new Date(),
      downloadLoading: false,
      showStations: [],
      excelSheets: [],
      pickerOptionsLimit: {
        disabledDate: function disabledDate(pTime) {
          return _this.userInfo.authorityId === '888' ? false : pTime.getTime() < new Date() - 62 * 86400 * 1000 || pTime.getTime() > new Date();
        }
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters('user', ['userInfo'])), mapGetters('stations', ['asyncStations'])),
  created: function created() {
    for (var i in this.asyncStations) {
      this.excelSheets.push({
        tableId: 'stationDailyDiffData' + this.asyncStations[i]['ID'],
        name: this.asyncStations[i]['statTag'] + '差异',
        tableRows: 4
      });
    }
  },
  methods: {
    exportExcel: function exportExcel(tableArr, excelName) {
      var _this2 = this;

      if (tableArr.length < 1) {
        _Message({
          message: '导出 sheet 为空',
          type: 'error',
          duration: 3 * 1000
        });

        return;
      }

      var sheetUnLoadCount = 0;
      tableArr.forEach(function (ele) {
        if (!document.getElementById(ele.tableId) || document.getElementById(ele.tableId) === undefined) {
          sheetUnLoadCount = 1;
        }
      });

      if (sheetUnLoadCount === 1) {
        _Message({
          message: '请核对过所有报表标签栏的数据后进行下载',
          type: 'error',
          duration: 5 * 1000
        });

        return;
      }

      this.downloadLoading = true;
      import('@/utils/Export2Excel').then(function (excel) {
        excel.export_table_to_excel(tableArr, moment(_this2.datePickerValue).format('YYYY年MM月') + excelName);
        _this2.downloadLoading = false;
      });
    }
  }
};